import { render, staticRenderFns } from "./text-code.vue?vue&type=template&id=6403f1f9&scoped=true"
import script from "./text-code.vue?vue&type=script&lang=js"
export * from "./text-code.vue?vue&type=script&lang=js"
import style0 from "./text-code.vue?vue&type=style&index=0&id=6403f1f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403f1f9",
  null
  
)

export default component.exports